import React, {useMemo} from "react";
import { useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { UsersFilter } from "./users-filter/UsersFilter";
import { UsersTable } from "./users-table/UsersTable";
import { UsersGrouping } from "./users-grouping/UsersGrouping";
import { useUsersUIContext } from "./UsersUIContext";

export function UsersCard() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }

  const usersUIContext = useUsersUIContext();
  const usersUIProps = useMemo(() => {
    return {
      ids: usersUIContext.ids,
      queryParams: usersUIContext.queryParams,
      setQueryParams: usersUIContext.setQueryParams,
      newUserButtonClick: usersUIContext.newUserButtonClick,
      openDeleteUsersDialog: usersUIContext.openDeleteUsersDialog,
      openEditUserPage: usersUIContext.openEditUserPage,
      openUpdateUsersStatusDialog:
        usersUIContext.openUpdateUsersStatusDialog,
      openFetchUsersDialog: usersUIContext.openFetchUsersDialog,
    };
  }, [usersUIContext]);
  return (
    <div id="user-card">
    <Card >
      <CardHeader title="User List">
        <CardHeaderToolbar>
        {
         (superadmin)?<button
            type="button"
            className="btn btn-primary"
            onClick={usersUIProps.newUserButtonClick}
          >
            New User
          </button>
          :
          <></>
        }
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <UsersFilter />
        {usersUIProps.ids.length > 0 && superadmin &&(
          <>
            <UsersGrouping />
          </>
        )}
        <UsersTable />
      </CardBody>
    </Card>
    </div>
  );
}
